import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useDebounce } from '../../../util/useDebounce.js';
import { Box } from '../../Box/Box.js';
import { RippleStyled } from './Ripple.styled.js';

/**
 * Ripple effect
 */
var Ripple = function Ripple(props) {
  var containerWidth = props.containerWidth,
    containerHeight = props.containerHeight,
    size = props.size,
    duration = props.duration,
    children = props.children;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    rippleCount = _React$useState2[0],
    setRippleCount = _React$useState2[1];
  var onClickHandler = function onClickHandler() {
    setRippleCount(rippleCount + 1);
  };
  var durationMs = duration * 1000;
  var resetRippleCount = function resetRippleCount() {
    return setRippleCount(0);
  };
  var resetRippleCountDebounced = useDebounce(resetRippleCount, durationMs);
  React.useLayoutEffect(function () {
    // TODO: ADSDEV-1164 Setup test environment that can handle debounce logic
    // Skip debounce logic in test environment
    if (process.env.NODE_ENV === 'test') return;
    if (rippleCount > 0) {
      resetRippleCountDebounced();
    }
  }, [rippleCount, duration, setRippleCount, resetRippleCountDebounced]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props -- @agoda/agoda-a11y/no-incorrect-props[ae32eb62-afee-4e96-b1c4-4cbc1c1be9b7]
    React.createElement(Box, {
      width: containerWidth,
      height: containerHeight,
      onClick: onClickHandler
    }, Array.from(Array(rippleCount).keys()).map(function (i) {
      return /*#__PURE__*/React.createElement(RippleStyled, {
        key: "ripple-".concat(i),
        $duration: duration,
        width: size,
        height: size,
        backgroundColor: "product.primary"
      });
    }), children)
  );
};
Ripple.displayName = 'Ripple';
Ripple.defaultProps = {
  containerWidth: '100%',
  containerHeight: '100%'
};

export { Ripple };
//# sourceMappingURL=Ripple.js.map
